import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "s16_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = { class: "s7_mobile container-full-2" }
const _hoisted_4 = { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }
const _hoisted_5 = { class: "s13 flex justify-content-right" }
const _hoisted_6 = {
  key: 0,
  class: "columns-selector-panel"
}
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = { class: "s20 items-center gap-6 px-0 pb-6 collapse-content active" }
const _hoisted_9 = {
  key: 0,
  class: "custom-filter-set-area my-5"
}
const _hoisted_10 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_11 = { class: "form-field-floating reactive sm" }
const _hoisted_12 = { class: "form-field-floating sm" }
const _hoisted_13 = { class: "form-field-floating sm" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-field-floating reactive sm" }
const _hoisted_16 = { class: "form-field-floating reactive sm" }
const _hoisted_17 = { class: "form-field-floating reactive sm" }
const _hoisted_18 = { class: "form-field-floating reactive sm" }
const _hoisted_19 = { class: "form-field-floating sm" }
const _hoisted_20 = { class: "form-field-floating sm" }
const _hoisted_21 = { class: "table separator skin3 selection rounded" }
const _hoisted_22 = {
  class: "btn-circle",
  for: "check-list1"
}
const _hoisted_23 = ["checked"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { key: 6 }
const _hoisted_31 = { key: 7 }
const _hoisted_32 = { key: 8 }
const _hoisted_33 = { key: 9 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  colspan: "12",
  class: "text-center py-5"
}
const _hoisted_36 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "selection-item" }
const _hoisted_39 = ["for"]
const _hoisted_40 = ["id", "value"]
const _hoisted_41 = {
  key: 0,
  class: "flex"
}
const _hoisted_42 = { class: "flex align-items-center bg-white h-100p" }
const _hoisted_43 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_44 = ["src"]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "text-xl font-semibold mb-2" }
const _hoisted_47 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_48 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_49 = {
  key: 2,
  class: "tag-state notif stroke"
}
const _hoisted_50 = {
  key: 3,
  class: "tag-state danger stroke"
}
const _hoisted_51 = { class: "text-sm text-grey-600" }
const _hoisted_52 = { class: "text-sm text-grey-600" }
const _hoisted_53 = {
  key: 2,
  class: "text-xl font-semibold"
}
const _hoisted_54 = {
  key: 3,
  class: "text-xl font-semibold"
}
const _hoisted_55 = {
  key: 4,
  class: "text-xl font-semibold"
}
const _hoisted_56 = {
  key: 5,
  class: "text-xl font-semibold"
}
const _hoisted_57 = {
  key: 6,
  class: "text-xl font-semibold"
}
const _hoisted_58 = {
  key: 7,
  class: "text-3xl"
}
const _hoisted_59 = { class: "mt-1 text-sm" }
const _hoisted_60 = { key: 8 }
const _hoisted_61 = { class: "text-xl font-semibold mb-2" }
const _hoisted_62 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_63 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_64 = {
  key: 2,
  class: "tag-state danger stroke"
}
const _hoisted_65 = { class: "flex-right gap-4" }
const _hoisted_66 = { class: "s4 pl-5 pr-7" }
const _hoisted_67 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_68 = { class: "single-chart s6" }
const _hoisted_69 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_70 = ["stroke-dasharray"]
const _hoisted_71 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_72 = { class: "s14 px-4" }
const _hoisted_73 = { class: "font-medium" }
const _hoisted_74 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_75 = { class: "single-chart s6" }
const _hoisted_76 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_77 = ["stroke-dasharray"]
const _hoisted_78 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_79 = { class: "s14 px-4" }
const _hoisted_80 = { class: "font-medium" }
const _hoisted_81 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_82 = { class: "single-chart s6" }
const _hoisted_83 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_84 = ["stroke-dasharray"]
const _hoisted_85 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_86 = { class: "s14 px-4" }
const _hoisted_87 = { class: "font-medium" }
const _hoisted_88 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_89 = { class: "single-chart s6" }
const _hoisted_90 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_91 = ["stroke-dasharray"]
const _hoisted_92 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_93 = { class: "s14 px-4" }
const _hoisted_94 = { class: "font-medium" }

import { computed, inject, onBeforeUnmount, onMounted, reactive, Ref, ref, watch } from 'vue';
    import axios from 'axios';
    import moment from 'moment';
    import { formatAmount, formatDate } from '@/utils';
    import { useToastStore } from '@/stores/toast.store';
    import { useConfirmationStore } from '@/stores/confirmation.store';
    import { useRoute } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementMembres',
  setup(__props) {

    const route = useRoute();
    const toastStore = useToastStore();
    const startupInfos = reactive<{ salaires: any[] }>(route.meta.item as any);
    const confirmationStore = useConfirmationStore();
    const loading = ref(false);
    const collectivite = inject<Ref<any>>('collectivite');
    const itemsList = ref<any[]>([]);
    const filteredDatas = ref([] as Array<any>);
    const paginatedFilteredDatas = ref([] as Array<any>);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const filtersParams = reactive({
        name: '',
        statut_professionnel: null,
        salaires: null,
        quotite_cessible_min: null,
        quotite_cessible_max: null,
        age_min: null,
        age_max: null,
        sexe: null,
        fonction: null
    });
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return paginatedFilteredDatas.value.length > 0 && selectedItems.value.filter(i => paginatedFilteredDatas.value.findIndex(p => p.id === i) !== -1).length === paginatedFilteredDatas.value.length;
    });
    const areAllItemsSelectedValidable = computed(() => {
        return selectedItems.value.length > 0 && itemsList.value.filter(i => selectedItems.value.includes(i.id) && i.statut_prospect == 0).length === selectedItems.value.length;
    });
    const showAdvancedFilters = ref(false);

    const columnsCatalog = [
        { key: 'photo', label: 'Photo' },
        { key: 'information', label: 'Information' },
        { key: 'date_naissance', label: 'Date de naissance', hidden: true },
        { key: 'age', label: 'Age', hidden: true },
        { key: 'sexe', label: 'Sexe', hidden: true },
        { key: 'retraite', label: 'Retraite', hidden: true },
        { key: 'salaire', label: 'Salaire', hidden: true },
        { key: 'utilisation', label: 'Utilisation', hidden: true },
        { key: 'statut', label: 'Statut', hidden: true },
    ];
    const visibleColumns = ref(columnsCatalog.filter(c => c.hidden === undefined || c.hidden === false).map(c => c.key));
    const showColumnsSelector = ref(false);
    const columnsSelectorRef = ref<HTMLElement | null>(null);

    const statsPersonnesActivesCount = computed(() => itemsList.value.filter(i => !i.retraite).length);
    const statsPersonnesActivesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesActivesCount.value * 100) / itemsList.value.length);
    });

    const statsPersonnesRetraitesCount = computed(() => itemsList.value.filter(i => i.retraite).length);
    const statsPersonnesRetraitesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesRetraitesCount.value * 100) / itemsList.value.length);
    });

    const statsPersonnesHommesCount = computed(() => itemsList.value.filter(i => i.sexe == 'M').length);
    const statsPersonnesHommesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesHommesCount.value * 100) / itemsList.value.length);
    });

    const statsPersonnesFemmesCount = computed(() => itemsList.value.filter(i => i.sexe == 'F').length);
    const statsPersonnesFemmesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesFemmesCount.value * 100) / itemsList.value.length);
    });

    onMounted(() => {
        fetchMembres();
        document.addEventListener('click', handleClickOutsideColumnsSelector);
    });

    watch(filtersParams, (oldValues, newValues) => {
        applyFilters();
        onPaginate(1);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('click', handleClickOutsideColumnsSelector);
    });

    async function fetchMembres() {
        try {
            loading.value = true;
            const response = await axios.get(`/backoffice/collectivites/${collectivite?.value.id}/membres`);
            itemsList.value = response.data;
            applyFilters();
            onPaginate(1);
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loading.value = false;
        }
    }

    function applyFilters() {
        let allDatas = itemsList.value;

        if (filtersParams.name) {
            allDatas = allDatas.filter(a => `${a.nom} ${a.prenom}`.toLowerCase().includes(filtersParams.name.toLowerCase()));
        }
        if (filtersParams.statut_professionnel) {
            if (filtersParams.statut_professionnel == '1') {
                allDatas = allDatas.filter(a => a.retraite === false);
            } else if (filtersParams.statut_professionnel == '2') {
                allDatas = allDatas.filter(a => a.retraite === true);
            }
        }
        if (filtersParams.sexe) {
            allDatas = allDatas.filter(a => a.sexe == filtersParams.sexe);
        }
        if (filtersParams.quotite_cessible_min != null && !isNaN(filtersParams.quotite_cessible_min)) {
            const quotite_cessible_min = parseFloat(filtersParams.quotite_cessible_min);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant >= quotite_cessible_min);
        }
        if (filtersParams.quotite_cessible_max != null && !isNaN(filtersParams.quotite_cessible_max)) {
            const quotite_cessible_max = parseFloat(filtersParams.quotite_cessible_max);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant <= quotite_cessible_max);
        }
        if (filtersParams.age_min) {
            const age_min = moment(filtersParams.age_min);
            if (age_min.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrAfter(age_min);
                })
            }
        }
        if (filtersParams.age_max) {
            const age_max = moment(filtersParams.age_max);
            if (age_max.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrBefore(age_max);
                })
            }
        }
        if (filtersParams.salaires != null) {
            const matchSalaire = startupInfos.salaires[filtersParams.salaires];
            if (matchSalaire) {
                allDatas = allDatas.filter(a => !isNaN(a.salaire) && parseFloat(a.salaire) >= parseFloat(matchSalaire.salaire_min) && parseFloat(a.salaire) <= parseFloat(matchSalaire.salaire_max));
            }
        }
        
        filteredDatas.value = allDatas;
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        pagination.total = filteredDatas.value.length;
        pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
        const start = (page - 1) * pagination.per_page;
        paginatedFilteredDatas.value =  filteredDatas.value.slice(start, start + pagination.per_page);
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = [...selectedItems.value.filter(s => itemsList.value.findIndex(p => p.id === s) === -1), ...itemsList.value.map(i => i.id)];
        } else {
            selectedItems.value = [];
        }
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

    function isColumnVisible(key: string) {
        return visibleColumns.value.includes(key);
    }

    function toggleColumn(key: string) {
        const index = visibleColumns.value.indexOf(key);
        if (index === -1) {
            visibleColumns.value.push(key);
        } else if (visibleColumns.value.length > 1) {
            visibleColumns.value.splice(index, 1);
        }
    }

    function toggleColumnsSelector() {
        showColumnsSelector.value = !showColumnsSelector.value;
    }

    function handleClickOutsideColumnsSelector(event: MouseEvent) {
        if (columnsSelectorRef.value && !columnsSelectorRef.value.contains(event.target as Node)) {
            showColumnsSelector.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("img", {
              src: "/icons/icon-info-perso.svg",
              class: "size-l",
              alt: ""
            }, null, -1)),
            _createTextVNode(" Membres (" + _toDisplayString(filteredDatas.value.length) + ") ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_custom_button, {
            type: "button",
            classesList: 'btn light',
            onClick: fetchMembres
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createElementVNode("img", {
                src: "/icons/icon-list.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Actualiser", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter",
            onClick: toggleAdvancedFilters
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("img", {
              src: "/icons/icon-filter.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Options", -1)
          ]))]),
          _createElementVNode("div", {
            class: "columns-selector s3_mobile ml-4",
            ref_key: "columnsSelectorRef",
            ref: columnsSelectorRef
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn normal justify-content-center white2 btn-filtre btn-filter",
              onClick: toggleColumnsSelector
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                src: "/icons/icon-list.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Colonnes", -1)
            ]))]),
            (showColumnsSelector.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnsCatalog, (col) => {
                    return _createElementVNode("label", {
                      class: "columns-selector-item",
                      key: col.key
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: isColumnVisible(col.key),
                        onChange: ($event: any) => (toggleColumn(col.key))
                      }, null, 40, _hoisted_7),
                      _createElementVNode("span", null, _toDisplayString(col.label), 1)
                    ])
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]),
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          (showAdvancedFilters.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtersParams.name) = $event)),
                      name: "name",
                      id: "name",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.name]
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("label", { for: "name" }, "Nom, prénoms", -1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtersParams.statut_professionnel) = $event)),
                      name: "statut_professionnel",
                      id: "statut_professionnel"
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("option", { value: null }, "Tous les statuts", -1),
                      _createElementVNode("option", { value: "1" }, "Actifs", -1),
                      _createElementVNode("option", { value: "2" }, "Retraités", -1)
                    ]))], 512), [
                      [_vModelSelect, filtersParams.statut_professionnel]
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("label", { for: "statut_professionnel" }, [
                      _createTextVNode("Statut "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtersParams.salaires) = $event)),
                      name: "salaires",
                      id: "salaires"
                    }, [
                      _cache[18] || (_cache[18] = _createElementVNode("option", { value: null }, "Tous les salaires", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.salaires, (salaire, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: index,
                          key: index
                        }, _toDisplayString(_unref(formatAmount)(salaire.salaire_min) + ' - ' + _unref(formatAmount)(salaire.salaire_max)), 9, _hoisted_14))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, filtersParams.salaires]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("label", { for: "salaires" }, [
                      _createTextVNode("Salaires "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtersParams.quotite_cessible_min) = $event)),
                      name: "quotite_cessible_min",
                      id: "quotite_cessible_min",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.quotite_cessible_min]
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("label", { for: "quotite_cessible_min" }, "Quotité cessible >=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtersParams.quotite_cessible_max) = $event)),
                      name: "quotite_cessible_max",
                      id: "quotite_cessible_max",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.quotite_cessible_max]
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("label", { for: "quotite_cessible_max" }, "Quotité cessible >=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtersParams.age_min) = $event)),
                      name: "age_min",
                      id: "age_min",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.age_min]
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "age_min" }, "Age >=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filtersParams.age_max) = $event)),
                      name: "age_max",
                      id: "age_max",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.age_max]
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("label", { for: "age_max" }, "Age <=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filtersParams.sexe) = $event)),
                      name: "sexe",
                      id: "sexe"
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("option", { value: null }, "Tous les sexes", -1),
                      _createElementVNode("option", { value: "M" }, "Masculin", -1),
                      _createElementVNode("option", { value: "F" }, "Féminin", -1)
                    ]))], 512), [
                      [_vModelSelect, filtersParams.sexe]
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("label", { for: "sexe" }, [
                      _createTextVNode("Sexe "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filtersParams.fonction) = $event)),
                      name: "fonction",
                      id: "fonction"
                    }, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("option", { value: null }, "Toutes les fonctions", -1)
                    ]))], 512), [
                      [_vModelSelect, filtersParams.fonction]
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("label", { for: "fonction" }, [
                      _createTextVNode("Fonction "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_21, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("label", _hoisted_22, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "check_all",
                      checked: areAllItemsSelected.value,
                      onChange: handleCheckAll
                    }, null, 40, _hoisted_23)
                  ])
                ]),
                (isColumnVisible('photo'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_24))
                  : _createCommentVNode("", true),
                (isColumnVisible('information'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_25, [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Information", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('date_naissance'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_26, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Date de naissance", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('age'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_27, [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Age", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('sexe'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_28, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Sexe", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('retraite'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_29, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Retraite", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('salaire'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_30, [...(_cache[33] || (_cache[33] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Salaire", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('utilisation'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_31, [...(_cache[34] || (_cache[34] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Utilisation", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('statut'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_32, [...(_cache[35] || (_cache[35] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Statut", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('contact'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_33, [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Contact", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _cache[37] || (_cache[37] = _createElementVNode("th", { class: "flex-right" }, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                    _createElementVNode("td", _hoisted_35, [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[38] || (_cache[38] = [
                            _createElementVNode("div", { class: "loader dark" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (paginatedFilteredDatas.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [...(_cache[39] || (_cache[39] = [
                      _createElementVNode("td", {
                        colspan: "12",
                        class: "text-center py-5"
                      }, " Aucun membre trouvé ", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginatedFilteredDatas.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "text-grey-700 over-effect",
                        key: 'item_' + index
                      }, [
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("label", {
                            class: "btn-circle",
                            for: 'item_check_' + index
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "selectedItems[]",
                              id: 'item_check_' + index,
                              value: item.id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedItems).value = $event))
                            }, null, 8, _hoisted_40), [
                              [_vModelCheckbox, selectedItems.value]
                            ])
                          ], 8, _hoisted_39)
                        ]),
                        (isColumnVisible('photo'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("img", {
                                    src: !!item.photo_url ? item.photo_url : '/assets/users_avatar/600w/user.jpg',
                                    width: "100%"
                                  }, null, 8, _hoisted_44)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (isColumnVisible('information'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                              _createElementVNode("p", _hoisted_46, [
                                _createTextVNode(_toDisplayString(item.nom + ' ' + item.prenom) + "   ", 1),
                                (!item.email_verified_at)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "En cours"))
                                  : _createCommentVNode("", true),
                                (item.email_verified_at)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Vérifié"))
                                  : _createCommentVNode("", true),
                                (item.actif == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Actif"))
                                  : _createCommentVNode("", true),
                                (item.actif == 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Inactif"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_51, _toDisplayString(item.email), 1),
                              _createElementVNode("p", _hoisted_52, _toDisplayString(item.telephone), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (isColumnVisible('date_naissance'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_53, _toDisplayString(_unref(formatDate)(item.date_naissance, 'DD/MM/YYYY')), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('age'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(item.age), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('sexe'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(item.sexe), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('retraite'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(item.retraite ? 'Oui' : 'Non'), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('salaire'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(_unref(formatAmount)(item.salaire)) + " F ", 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('utilisation'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_58, [
                              (item.quotite_cessible_pourcent)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(item.quotite_cessible_pourcent) + "% ", 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("-")
                                  ], 64)),
                              _createElementVNode("p", _hoisted_59, [
                                (item.quotite_cessible_montant)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(new Intl.NumberFormat('fr-FR').format(item.quotite_cessible_montant)) + " F ", 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (isColumnVisible('statut'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_60, [
                              _createElementVNode("p", _hoisted_61, [
                                (item.statut_prospect == 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, "En attente"))
                                  : _createCommentVNode("", true),
                                (item.statut_prospect == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Validé"))
                                  : _createCommentVNode("", true),
                                (item.statut_prospect == -1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Rejeté"))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_router_link, {
                              to: '/app/users/form/' + item.id
                            }, {
                              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                _createElementVNode("button", { class: "btn tips" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-edit.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }),
                                  _createElementVNode("span", null, "Editer")
                                ], -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"]),
                            (item.deleted_at == null && item.actif == 1)
                              ? (_openBlock(), _createBlock(_component_custom_button, {
                                  key: 0,
                                  classesList: 'btn-ultra color2 tips'
                                }, {
                                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                    _createElementVNode("img", {
                                      src: "/icons/icon-actif.svg",
                                      class: "btn-icon",
                                      alt: ""
                                    }, null, -1),
                                    _createElementVNode("span", null, "Actif", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (item.deleted_at == null && item.actif == 0)
                              ? (_openBlock(), _createBlock(_component_custom_button, {
                                  key: 1,
                                  classesList: 'btn-ultra color2 tips'
                                }, {
                                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                    _createElementVNode("img", {
                                      src: "/icons/icon-inactif.svg",
                                      class: "btn-icon",
                                      alt: ""
                                    }, null, -1),
                                    _createElementVNode("span", null, "Inactif", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_router_link, {
                              to: '/app/users/' + item.id + '/details'
                            }, {
                              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                _createElementVNode("button", { class: "btn white2 active" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-consulter.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }),
                                  _createElementVNode("span", null, "Gérer")
                                ], -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"]),
                            _createVNode(_component_router_link, {
                              to: '/app/users/' + item.id + '/carte'
                            }, {
                              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                _createElementVNode("button", { class: "btn white2 active" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-consulter.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }),
                                  _createElementVNode("span", null, "Carte")
                                ], -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"]),
                            _createVNode(_component_router_link, {
                              to: '/app/users/' + item.id + '/utilisation'
                            }, {
                              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                _createElementVNode("button", { class: "btn white2 active" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-consulter.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }),
                                  _createElementVNode("span", null, "Utilisation")
                                ], -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"]),
                            _createVNode(_component_router_link, {
                              to: '/app/users/' + item.id + '/plan'
                            }, {
                              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                _createElementVNode("button", { class: "btn white2 active" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-consulter.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }),
                                  _createElementVNode("span", null, "Plan")
                                ], -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"]),
                            _createVNode(_component_router_link, {
                              to: '/app/users/' + item.id + '/revolving'
                            }, {
                              default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                _createElementVNode("button", { class: "btn white2 active" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-consulter.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }),
                                  _createElementVNode("span", null, "Revolving")
                                ], -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ])
                      ]))
                    }), 128))
            ])
          ]),
          _createVNode(_component_custom_pagination, {
            modelValue: queryParams.pageNumber,
            "onUpdate:modelValue": [
              _cache[10] || (_cache[10] = ($event: any) => ((queryParams.pageNumber) = $event)),
              onPaginate
            ],
            total: pagination.total,
            "per-page": pagination.per_page,
            last_page: pagination.last_page
          }, null, 8, ["modelValue", "total", "per-page", "last_page"])
        ]),
        _cache[49] || (_cache[49] = _createElementVNode("div", { class: "clear-both" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          (_openBlock(), _createElementBlock("svg", _hoisted_69, [
            _cache[50] || (_cache[50] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesActivesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_70),
            _createElementVNode("text", _hoisted_71, _toDisplayString(statsPersonnesActivesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("h3", _hoisted_73, _toDisplayString(statsPersonnesActivesCount.value), 1),
          _cache[51] || (_cache[51] = _createElementVNode("h6", { class: "font-medium" }, "Personnes actives", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          (_openBlock(), _createElementBlock("svg", _hoisted_76, [
            _cache[52] || (_cache[52] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray":  statsPersonnesRetraitesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_77),
            _createElementVNode("text", _hoisted_78, _toDisplayString(statsPersonnesRetraitesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("h3", _hoisted_80, _toDisplayString(statsPersonnesRetraitesCount.value), 1),
          _cache[53] || (_cache[53] = _createElementVNode("h6", { class: "font-medium" }, "Personnes retraités", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          (_openBlock(), _createElementBlock("svg", _hoisted_83, [
            _cache[54] || (_cache[54] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesHommesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_84),
            _createElementVNode("text", _hoisted_85, _toDisplayString(statsPersonnesHommesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("h3", _hoisted_87, _toDisplayString(statsPersonnesHommesCount.value), 1),
          _cache[55] || (_cache[55] = _createElementVNode("h6", { class: "font-medium" }, "Hommes", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          (_openBlock(), _createElementBlock("svg", _hoisted_90, [
            _cache[56] || (_cache[56] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesFemmesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_91),
            _createElementVNode("text", _hoisted_92, _toDisplayString(statsPersonnesFemmesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("h3", _hoisted_94, _toDisplayString(statsPersonnesFemmesCount.value), 1),
          _cache[57] || (_cache[57] = _createElementVNode("h6", { class: "font-medium" }, "Femmes", -1))
        ])
      ])
    ])
  ], 64))
}
}

})